/* unplugin-vue-components disabled */import __unplugin_components_1 from '/var/repos/bic-vue/src/components/login/RegisterForm.vue';
import __unplugin_components_0 from '/var/repos/bic-vue/src/components/login/LoginForm.vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "text-3xl text-center mb-6 text-white"
};
const _hoisted_2 = {
  class: "flex justify-center gap-2 mb-8"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 1
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 1
};
export default {
  __name: 'SignInForm',
  props: {
    whichForm: {
      type: String,
      default: 'login'
    },
    shouldRefresh: {
      type: Boolean,
      default: false
    }
  },
  emits: ['userLoggedIn'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const props = __props;
    const activeForm = ref(props.whichForm);
    function onLoggedIn() {
      emit('userLoggedIn');
    }
    return (_ctx, _cache) => {
      const _component_LoginForm = __unplugin_components_0;
      const _component_RegisterForm = __unplugin_components_1;
      return _openBlock(), _createElementBlock("div", {
        key: _unref(activeForm),
        class: "form-wrapper"
      }, [_createElementVNode("h2", _hoisted_1, _toDisplayString(_unref(activeForm) === 'login' ? 'Log in' : 'Sign up'), 1), _createElementVNode("div", _hoisted_2, [_unref(activeForm) === 'login' ? (_openBlock(), _createElementBlock("p", _hoisted_3, [_createTextVNode("Don't have an account? "), _createElementVNode("button", {
        class: "underline",
        onClick: _cache[0] || (_cache[0] = $event => activeForm.value = 'register')
      }, " Register ")])) : (_openBlock(), _createElementBlock("p", _hoisted_4, [_createTextVNode("Already have an account? "), _createElementVNode("button", {
        class: "underline",
        onClick: _cache[1] || (_cache[1] = $event => activeForm.value = 'login')
      }, " Login ")]))]), _unref(activeForm) === 'login' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_LoginForm, {
        onLoggedIn: onLoggedIn
      })])) : (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_RegisterForm)]))]);
    };
  }
};